import { Trans } from "@lingui/macro";

import { Text, Box } from "@whoosh/design-system/src/components/primitive";

const NotConnected = () => (
  <Box flex={1} safeArea alignItems="center" justifyContent="center" px={8}>
    <Text
      accessibilityRole="header"
      variant="mainTitle3"
      maxFontSizeMultiplier={2}
      textAlign="center"
      mb={2}
    >
      <Trans>Oops! Looks like you're not connected to the internet.</Trans>
    </Text>
    <Text maxFontSizeMultiplier={2} textAlign="center">
      <Trans>Please check your connection and reload the app.</Trans>
    </Text>
  </Box>
);

export default NotConnected;
